import React from 'react';
import Link from 'gatsby-link';

import Button from '@marvelapp/marvel-ui/button';
import MaxWidth from '@marvelapp/marvel-ui/max-width';
import Spacing from '@marvelapp/marvel-ui/spacing';

import MarvelEnterprise from 'marketing-website/components/modules/MarvelEnterprise';
import Image from 'marketing-website/components/modules/Image';
import IntegrationsCta from 'marketing-website/components/modules/IntegrationsCta';
import Page from 'marketing-website/components/modules/Page';
import Whitespace from 'marketing-website/components/commons/Whitespace';

import MarvelThreeUT from 'marketing-website/media/images/pages/user-testing/marvelEnterprise@2x.jpg';
import metaData from 'marketing-website/data/metadata.js';

import Automated from './Automated';
import Collaboration from './Collaboration';
import Creativity from './Creativity';
import Interactive from './Interactive';
import FooterCta from './FooterCta';
import styles from './style/general.module.css';

export default function WhyMarvel() {
  return (
    <Page
      title={metaData['why-marvel'].title}
      meta={[
        {
          name: 'description',
          content: metaData['why-marvel'].description,
        },
      ]}
      header
      footer
    >
      <div className="overflow-hidden">
        <div className={styles.wrap}>
          <h1 className={styles.heading}>
            Everything you need to bring ideas to life
          </h1>
          <Spacing size="l" type="padding" position="bottom">
            <MaxWidth value={720}>
              <h2 className={styles.subheading}>
                With the Marvel design platform, access all the core
                functionality you need to build digital products - wireframe,
                prototype and generate design specs in one place.
              </h2>
            </MaxWidth>
          </Spacing>
          <div className={styles.buttons}>
            <div className={styles.margin}>
              <Link to="/signup/">
                <Button size="large" shape="rounded" minWidth={170}>
                  Sign up free
                </Button>
              </Link>
            </div>
            <div>
              <Link to="/pricing/">
                <Button
                  size="large"
                  kind="ghost"
                  shape="rounded"
                  minWidth={170}
                >
                  Explore Plans
                </Button>
              </Link>
            </div>
          </div>
        </div>
        <Creativity />
        <Interactive />
        <Whitespace size="l" />
        <Automated />
        <Whitespace size="xl" />
        <Collaboration />
        <MarvelEnterprise
          buttonText="Learn more"
          copy={
            <span>
              Each stage of the design process unified in one platform - where
              you and your team, no matter the size can wireframe, prototype,
              user test and handoff to developers collaboratively.
              <br />
              <br />
              Marvel Enterprise 3 has been built on blazing fast technology with
              features that focus on helping large teams make design more
              productive.
            </span>
          }
          image={
            <Image
              alt={'Marvel Enterprise Dashboard and UserTesting Dashboard'}
              hasShadow={false}
              maxWidth={700}
              src={MarvelThreeUT}
            />
          }
          title="Design, test and scale, together"
        />
        <IntegrationsCta />
        <FooterCta />
      </div>
    </Page>
  );
}



// WEBPACK FOOTER //
// ./src/pages/why-marvel/index.js